import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const calendarMonthsListCellFn = /* @__PURE__ */ createRecipe('calendar-months-list-cell', {}, [])

const calendarMonthsListCellVariantMap = {}

const calendarMonthsListCellVariantKeys = Object.keys(calendarMonthsListCellVariantMap)

export const calendarMonthsListCell = /* @__PURE__ */ Object.assign(memo(calendarMonthsListCellFn.recipeFn), {
  __recipe__: true,
  __name__: 'calendarMonthsListCell',
  __getCompoundVariantCss__: calendarMonthsListCellFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: calendarMonthsListCellVariantKeys,
  variantMap: calendarMonthsListCellVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, calendarMonthsListCellVariantKeys)
  },
  getVariantProps: calendarMonthsListCellFn.getVariantProps,
})